import { CellContext } from "@tanstack/react-table";
import type { ViewTableFeatures } from "@design-system/ViewTable/core/table";
import { memo } from "react";
import { InvoiceLineItem } from "@common/types/invoice";
import { ViewTableCell } from "@design-system/ViewTable/ViewTableCell";
import styles from "./DescriptionCell.module.scss";

export const DescriptionCell = memo(
    ({ row }: CellContext<ViewTableFeatures, InvoiceLineItem, unknown>) => {
        const lineItem = row.original;
        const hasDescription = (lineItem.description ?? "").trim().length > 0;

        return (
            <ViewTableCell className={styles.description}>
                {hasDescription ? lineItem.description : null}
            </ViewTableCell>
        );
    },
);
